namespace $.$$ {
	$mol_style_define( $shm_hitalama_components_version, {
		width: '30rem', maxWidth: '100%', flex: { grow: 0, shrink: 0, basis: '30rem' },
		Note: { minWidth: 0, maxWidth: '100%', overflowWrap: 'anywhere' },
		Details: { minWidth: 0, maxWidth: '100%', overflowWrap: 'anywhere' },
	})
}
